import { __awaiter, __extends, __generator } from "tslib";
import { CacheKey, Topology } from '@wix/wixstores-client-core';
import { query as getClientConfigSlimQuery } from '../../graphql/getClientConfigSlim.graphql';
import { EcomHttpClient } from '../site-store/EcomHttpClient';
import { OnlineStoresSettingsModel } from './OnlineStoresSettingsModel';
var WARMUP_DATA_KEY = 'onlineStoresClientConfig';
var OnlineStoresSettingsService = /** @class */ (function (_super) {
    __extends(OnlineStoresSettingsService, _super);
    function OnlineStoresSettingsService(params) {
        var _this = _super.call(this, params) || this;
        _this.getStoreCountry = params.getStoreCountry;
        _this.getStoreLanguage = params.getStoreLanguage;
        _this.storage = params.storage;
        _this.windowApis = params.windowApis;
        _this.isSiteMode = params.isSiteMode;
        return _this;
    }
    OnlineStoresSettingsService.prototype.getOnlineStoresSettings = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.clientConfigPromise) {
                    this.clientConfigPromise = this.fetchOnlineStoresProperties();
                }
                return [2 /*return*/, this.clientConfigPromise];
            });
        });
    };
    OnlineStoresSettingsService.prototype.fetchOnlineStoresProperties = function () {
        return __awaiter(this, void 0, void 0, function () {
            var cached, variables, response, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.isSSR()) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getFromWarmupDataOrFromCache()];
                    case 1:
                        cached = _a.sent();
                        if (cached) {
                            return [2 /*return*/, cached];
                        }
                        _a.label = 2;
                    case 2:
                        variables = {
                            withPremiumFeatures: !this.isSSR(),
                            countryKeys: [this.getStoreCountry()],
                            language: this.getStoreLanguage(),
                        };
                        return [4 /*yield*/, this.tryGetGqlAndFallbackToPost(this.resolveAbsoluteUrl("/".concat(Topology.STOREFRONT_GRAPHQL_URL)), {
                                query: getClientConfigSlimQuery,
                                variables: variables,
                                source: 'WixStoresWebClient',
                                operationName: 'getConfigSlim',
                            })];
                    case 3:
                        response = _a.sent();
                        data = response.data;
                        if (this.isSiteMode()) {
                            this.setToCache(JSON.stringify(data));
                        }
                        if (this.isSSR()) {
                            this.windowApis.warmupData.set(WARMUP_DATA_KEY, data);
                        }
                        return [2 /*return*/, OnlineStoresSettingsModel.fromGQL({ data: data })];
                }
            });
        });
    };
    OnlineStoresSettingsService.prototype.getFromWarmupDataOrFromCache = function () {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var warmupConfig, cache, cachedData;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, ((_b = (_a = this.windowApis.warmupData).waitForWarmupData) === null || _b === void 0 ? void 0 : _b.call(_a, WARMUP_DATA_KEY))];
                    case 1:
                        _c.sent();
                        warmupConfig = this.windowApis.warmupData.get(WARMUP_DATA_KEY);
                        if (warmupConfig === null || warmupConfig === void 0 ? void 0 : warmupConfig.clientConfig) {
                            return [2 /*return*/, OnlineStoresSettingsModel.fromGQL({ data: warmupConfig })];
                        }
                        cache = this.getFromCache();
                        if (cache) {
                            cachedData = JSON.parse(cache);
                            if (cachedData.clientConfig) {
                                return [2 /*return*/, OnlineStoresSettingsModel.fromGQL({ data: cachedData })];
                            }
                        }
                        return [2 /*return*/, null];
                }
            });
        });
    };
    OnlineStoresSettingsService.prototype.getFromCache = function () {
        return this.storage.memory.getItem(CacheKey.GET_CONFIG);
    };
    OnlineStoresSettingsService.prototype.setToCache = function (data) {
        this.storage.memory.setItem(CacheKey.GET_CONFIG, data);
    };
    return OnlineStoresSettingsService;
}(EcomHttpClient));
export { OnlineStoresSettingsService };
//# sourceMappingURL=OnlineStoresSettingsService.js.map